import React from 'react';
import { ConformityDeclarationConfig } from '../../types/submission';

interface ConformityDeclarationSectionProps {
  config: ConformityDeclarationConfig;
  onConfigChange: (config: ConformityDeclarationConfig) => void;
  deadline?: string;
  disabled?: boolean;
  language?: string;
}

const ConformityDeclarationSection: React.FC<ConformityDeclarationSectionProps> = ({
  config,
  onConfigChange,
  deadline,
  disabled = false,
  language = 'de'
}) => {
  const handleEnabledChange = (enabled: boolean) => {
    onConfigChange({
      ...config,
      enabled,
      deadline: enabled ? deadline : ''
    });
  };

  const translations = {
    de: {
      title: 'Konformitätserklärung mitversenden',
      description: 'Verwendet die gleiche Deadline wie der Hauptfragebogen'
    },
    en: {
      title: 'Include Conformity Declaration',
      description: 'Uses the same deadline as the main questionnaire'
    }
  };

  const t = translations[language as 'de' | 'en'] || translations.de;

  return (
    <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
      <label className="flex items-start space-x-3 cursor-pointer">
        <input
          type="checkbox"
          checked={config.enabled}
          onChange={(e) => handleEnabledChange(e.target.checked)}
          className="mt-0.5 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
          disabled={disabled}
        />
        <div className="flex-1">
          <div className="text-xs font-medium text-blue-900">
            {t.title}
          </div>
          <div className="text-xs text-blue-700 mt-1">
            {t.description}
          </div>
        </div>
      </label>
    </div>
  );
};

export default ConformityDeclarationSection;
